import { GetterTree } from "vuex/types/index"

import { RootState } from "~/store/store.types"
import { getResource } from "~/utils/store"

import { InquiryState, InquiryResource } from "./inquiries.types"

const getters: GetterTree<InquiryState, RootState> = {
  resourceById (state, _, __, rootGetters) {
    return (id: string, withRelationships: string[]) => {
      return getResource<InquiryResource>(state, id, rootGetters, withRelationships)
    }
  },

  inquiries (state, _, __, rootGetters) {
    if (state.data) {
      return Object.values(state.data).map(inquiry =>
        getResource<InquiryResource>(state, inquiry.id, rootGetters, []))
    }
    
    return []
  }
}

export default getters
